import List from './list'
import Receipt from './receipt'
import Template from './template'

export default function(prefix, app) {
  return app
    .useRoute(`${prefix}/list/receipt/:id`, Receipt)
    .useRoute(`${prefix}/list/template`, Template)
    .useRoute(`${prefix}/list`, List)
}
